import { z } from 'zod';

type PostsFilter = z.infer<typeof filtersFormSchema>;

const PUBLISHED_IN_DAYS_OPTIONS = ['1', '7', '30'] as const satisfies string[];
const PUBLISHED_IN_ALL_TIME_OPTION = 'all';

const baseSchema = z.object({
	userTags: z.array(z.string()).optional(),
});

const filtersFormSchema = z
	.discriminatedUnion('publishedInLastDays', [
		z.object({
			publishedInLastDays: z.literal('custom'),
			publishedInCustomPeriod: z.object({
				startDate: z.date(),
				endDate: z.date(),
			}),
		}),
		z.object({
			publishedInLastDays: z.enum([PUBLISHED_IN_ALL_TIME_OPTION, ...PUBLISHED_IN_DAYS_OPTIONS]),
		}),
	])
	.and(baseSchema)
	.and(
		z.discriminatedUnion('careRecipients', [
			z.object({
				careRecipients: z.literal('everyone'),
			}),
			z.object({
				careRecipients: z.literal('selected'),
				selectedCareRecipients: z.array(z.string()),
			}),
		]),
	);

export { PostsFilter, filtersFormSchema, PUBLISHED_IN_ALL_TIME_OPTION, PUBLISHED_IN_DAYS_OPTIONS };
